import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConsentService } from './consent.service';
import { ConsentState } from './consent.types';

/**
 * The cookie banner and the preferences dialog behind the footer's
 * "Do Not Sell or Share" link. Renders nothing on hosts where no tags load
 * (see ConsentService.applies), so localhost, CI and the visual baselines
 * are untouched.
 */
@Component({
    selector: 'app-consent-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './consent-banner.component.html',
    styleUrl: './consent-banner.component.css'
})
export class ConsentBannerComponent implements OnDestroy {
    /** Banner visible until a choice is recorded. */
    showBanner = false;

    /** Preferences dialog. */
    showPreferences = false;

    /** Working copy of the toggles while the dialog is open. */
    draft: ConsentState;

    private openSub: Subscription;

    constructor(public consent: ConsentService) {
        this.showBanner = consent.needsChoice;
        this.draft = { ...consent.state };
        // The footer's "Do not sell or share" link opens this dialog.
        this.openSub = consent.openRequests$.subscribe(() => this.openPreferences());
    }

    ngOnDestroy(): void {
        this.openSub.unsubscribe();
    }

    get applies(): boolean {
        return this.consent.applies;
    }

    get gpc(): boolean {
        return this.consent.gpc;
    }

    openPreferences(): void {
        this.draft = { ...this.consent.state };
        this.showPreferences = true;
    }

    closePreferences(): void {
        this.showPreferences = false;
    }

    toggle(category: keyof ConsentState): void {
        if (category === 'ads' && this.gpc) return;
        this.draft = { ...this.draft, [category]: !this.draft[category] };
    }

    acceptAll(): void {
        this.consent.acceptAll();
        this.dismiss();
    }

    rejectNonEssential(): void {
        this.consent.rejectNonEssential();
        this.dismiss();
    }

    savePreferences(): void {
        this.consent.set(this.draft);
        this.dismiss();
    }

    private dismiss(): void {
        this.showBanner = false;
        this.showPreferences = false;
    }
}
